{
  "manager": {
    "title": "Dashboard",
    "welcome": "Here's an overview of your appointments and leads.",
    "loading": "Loading dashboard...",
    "refresh": "Refresh",
    "servicesUnreachable": "Some services are unreachable",
    "failedAppointments": "Failed to load appointments.",
    "failedLeads": "Failed to load leads.",
    "retry": "Retry",
    "stats": {
      "totalAppointments": "Total Appointments",
      "todaysAppointments": "Today's Appointments",
      "thisWeek": "This Week",
      "totalLeads": "Total Leads",
      "newLeads": "New Leads",
      "convertedLeads": "Converted"
    },
    "quickActions": {
      "title": "Quick Actions",
      "scheduleAppointment": "Schedule Appointment",
      "scheduleAppointmentDesc": "Create a new appointment for a client",
      "viewCalendar": "View Calendar",
      "viewCalendarDesc": "See all appointments in calendar view",
      "manageLeads": "Manage Leads",
      "manageLeadsDesc": "View and manage all client leads",
      "manageResources": "Manage Resources",
      "manageResourcesDesc": "Configure staff, rooms & equipment"
    },
    "leadPipeline": {
      "title": "Lead Pipeline",
      "noLeads": "No leads yet",
      "noLeadsHint": "Leads will appear here as they are captured through your channels."
    },
    "appointmentOverview": {
      "title": "Appointment Overview",
      "allOperational": "All systems operational",
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "noShow": "No Show"
    },
    "todaysAppointments": {
      "title": "Today's Appointments",
      "noAppointments": "No appointments scheduled for today",
      "noAppointmentsHint": "Your schedule is clear for today.",
      "viewAll": "View Calendar",
      "anonymous": "Anonymous",
      "resource": "Resource {{id}}"
    },
    "recentLeads": {
      "title": "Recent Leads",
      "noLeads": "No leads found",
      "noLeadsHint": "Leads will appear here as they are captured.",
      "viewAll": "View All ({{count}})"
    },
    "upcomingAppointments": {
      "title": "Upcoming Appointments",
      "noAppointments": "No upcoming appointments",
      "noAppointmentsHint": "Schedule appointments to see them here.",
      "viewAll": "View Calendar"
    },
    "totalAppointments": "Total Appointments",
    "completedThisWeek": "Completed This Week",
    "activeClientLeads": "Active Client Leads",
    "statusOverview": "Appointment Status Overview",
    "completed": "Completed",
    "scheduled": "Scheduled",
    "confirmed": "Confirmed",
    "inProgress": "In Progress",
    "cancelled": "Cancelled",
    "scheduleNew": "Schedule New Appointment",
    "addNewClient": "Add New Client",
    "viewCalendar": "View Calendar",
    "sendReminders": "Send Reminders",
    "todaysAppointmentsCard": "Today's Appointments",
    "recentClientLeads": "Recent Client Leads",
    "noAppointmentsToday": "No appointments scheduled for today",
    "anonymousLead": "Anonymous Lead",
    "table": {
      "resource": "Resource"
    }
  },
  "admin": {
    "title": "Admin Dashboard",
    "welcome": "Welcome to the admin panel"
  },
  "client": {
    "title": "Client Dashboard",
    "welcome": "Welcome back",
    "subtitle": "Your appointments and messages at a glance",
    "stats": {
      "upcomingThisWeek": "Upcoming this week",
      "upcomingToday": "Upcoming today",
      "totalAppointments": "Your appointments",
      "openThreads": "Messages",
      "pendingRequests": "Pending reschedule requests"
    },
    "upcomingAppointments": {
      "title": "Upcoming appointments",
      "viewCalendar": "View calendar",
      "empty": "No upcoming appointments",
      "anonymous": "Appointment",
      "video": "Video",
      "inPerson": "In person"
    },
    "pendingRequests": {
      "title": "Pending reschedule requests",
      "empty": "No pending reschedule requests",
      "requested": "Requested",
      "statuses": {
        "PENDING": "Pending",
        "APPROVED": "Approved",
        "REJECTED": "Rejected",
        "CANCELLED": "Cancelled"
      }
    },
    "changeRequest": {
      "title": "Request Appointment Change",
      "sendRequest": "Send Request",
      "requestType": "Request type",
      "typeReschedule": "Reschedule Appointment",
      "typeCancel": "Cancel Appointment",
      "currentAppointment": "Current appointment",
      "chooseNewTime": "Choose a new time",
      "durationMinutes": "{{minutes}} min",
      "additionalInfo": "Additional Information",
      "additionalInfoPlaceholder": "Optional notes for the provider",
      "cancelReason": "Reason for Cancellation",
      "appointmentLabel": "Appointment",
      "deadlineBlocked": "This appointment starts in one hour or less and can no longer be rescheduled or cancelled online. Please contact us directly for assistance.",
      "activeRequestExists": "A change request is already pending for this appointment.",
      "pendingOnAppointment": "A change request is pending review for this appointment.",
      "rescheduleInfo": "The selected date and time are subject to confirmation. Your appointment will not be rescheduled until the request is approved.",
      "cancelInfo": "Your appointment will be cancelled immediately and the time slot will be released.",
      "rescheduleSubmitted": "Your rescheduling request has been submitted successfully. You will receive a confirmation after it has been reviewed.",
      "cancelSubmitted": "Your appointment has been cancelled successfully.",
      "cancelAppointment": "Cancel Appointment",
      "alreadyCancelled": "This appointment has already been cancelled.",
      "sameTimeAsCurrent": "Please choose a different date and time from your current appointment.",
      "submitFailed": "Failed to submit the change request."
    },
    "quickActions": {
      "title": "Quick Actions",
      "viewCalendar": "View Calendar",
      "requestChange": "Request Change",
      "messages": "Messages",
      "profile": "Profile"
    },
    "scopeRequired": {
      "dashboard": "Select a tenant and customer in the header to view the client portal",
      "calendar": "Select a tenant and customer in the header to view the calendar",
      "threads": "Select a tenant and customer in the header to view conversations",
      "thread": "Select a customer in the header to view this conversation"
    },
    "calendar": {
      "subtitle": "View your appointments"
    }
  }
}
